import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    id_curso_escolar: Yup.string().required('El curso escolar es obligatorio'),
    fecha:            Yup.string().required('La fecha es obligatoria'),
    id_origen:        Yup.string().required('El origen es obligatorio'),
    id_causa:         Yup.string().required('La causa es obligatoria'),
    motivo:           Yup.string().required('El motivo es obligatorio'),
})